<template>
  <div class="role-switcher">
    <el-select v-model="selectedRole" placeholder="切换角色" size="small" @change="onSwitch" style="width:140px">
      <el-option v-for="r in roles" :key="r.id" :label="r.name" :value="r.id" />
    </el-select>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import request from '@/utils/request';
import { roleApi } from '@/api/system';
import { dcApi } from '@/api/datacenter';
import { roleDataScope, roleGroupLevel } from '@/config/pcMenus';

export default {
  name: 'RoleSwitcher',
  data() {
    return { selectedRole: '' };
  },
  computed: {
    ...mapState(['userId', 'currentRoleId', 'roles'])
  },
  created() {
    this.loadRoles();
  },
  methods: {
    ...mapMutations(['setCurrentRole', 'setRoles', 'setMenuKeys', 'setDcScope']),
    async loadRoles() {
      try {
        const d = await request.get('/sys/user/' + this.userId + '/role-details');
        const roles = Array.isArray(d) ? d : [];
        this.setRoles(roles);
        if (roles.length > 0) {
          const saved = this.currentRoleId;
          const active = roles.find(r => String(r.id) === String(saved)) || roles[0];
          this.selectedRole = active.id;
          await this.applyRole(active);
        }
      } catch (e) { /* ignore */ }
    },
    async applyRole(role) {
      const scope = role.dataScope || roleDataScope(role.code);
      const groupLevel = roleGroupLevel(role.code);
      this.setCurrentRole({
        id: role.id,
        code: role.code,
        name: role.name,
        dataScope: scope,
        groupLevel
      });
      if (role.code === 'SUPER_ADMIN') {
        this.setMenuKeys(null);
      } else {
        try {
          const keys = await roleApi.getMenus(role.id);
          this.setMenuKeys(keys ? Array.from(keys) : []);
        } catch (e) {
          this.setMenuKeys([]);
        }
      }
      await this.applyDcScope(role);
    },
    async applyDcScope(role) {
      try {
        const dc = await dcApi.myScope();
        this.setDcScope(dc || {});
        if (role.code !== 'SUPER_ADMIN' && dc && dc.menuKeys && dc.menuKeys.length) {
          const sys = this.$store.state.menuKeys;
          if (sys && sys.length) {
            const allow = new Set(dc.menuKeys);
            this.setMenuKeys(sys.filter(k => !String(k).startsWith('datacenter/') || allow.has(k)));
          }
        }
      } catch (e) {
        this.setDcScope({});
      }
    },
    async onSwitch(roleId) {
      const role = this.roles.find(r => String(r.id) === String(roleId));
      if (role) {
        await this.applyRole(role);
        this.$root.$emit('role-changed', role);
      }
    }
  }
};
</script>
